import React from "react";

/**
 * Small circular avatar that shows which household member added a grocery
 * item. Used inline in list rows.
 */
export default function AddedByAvatar({ member }) {
  if (!member) return null;
  return (
    <span
      title={`Added by ${member.name || member.email || ""}`}
      data-testid={`grocery-avatar-${member.id}`}
      className="w-7 h-7 rounded-full bg-hearth-clay text-hearth-cream text-[11px] font-sans font-semibold grid place-items-center shadow-sm ring-2 ring-hearth-paper shrink-0"
    >
      {member.initials || "?"}
    </span>
  );
}
